import { render, staticRenderFns } from "./allot-dialog.vue?vue&type=template&id=073736de&scoped=true&"
import script from "./allot-dialog.vue?vue&type=script&lang=ts&"
export * from "./allot-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073736de",
  null
  
)

component.options.__file = "allot-dialog.vue"
export default component.exports